var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.646,
    height: 34.241,
    viewBox: "0 0 36.646 34.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-hipchat",
    "data-name": "Icon simple-hipchat",
    d: "M6.511,29.076s-.157-.111-.408-.3A14.931,14.931,0,0,1,0,16.987C0,8.261,8.2,1.181,18.318,1.181s18.327,7.08,18.327,15.807S28.445,32.8,18.326,32.8a21.013,21.013,0,0,1-3.854-.348l-.4-.069a19.07,19.07,0,0,1-9.6,3.039.984.984,0,0,1-.843-1.686,18.546,18.546,0,0,0,2.883-4.66Zm2.232-6.911a11.844,11.844,0,0,0,9.549,4.411h.07a11.859,11.859,0,0,0,9.549-4.411,1.736,1.736,0,0,0,.417-.876.748.748,0,0,0-.683-.8.082.082,0,0,0-.032,0,.96.96,0,0,0-.5.169,13.951,13.951,0,0,1-8.786,3.139,13.444,13.444,0,0,1-8.795-3.144.7.7,0,0,0-.478-.186.736.736,0,0,0-.737.725,2.017,2.017,0,0,0,.409.982h.017Z",
    transform: "translate(0 -1.18)",
    fill: "#b5aaff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.29fa83e1dc27c9530b14f83f8d210946.svg";
export { ForwardRef as ReactComponent };